<template>
  <v-container
    fill-height
    fluid
    class="ma-0 pa-2"
    style="
      max-height: 100%;
      overflow-y: hidden;
      background: var(--color-primary);
    "
  >
    <v-row no-gutters style="height: 50%">
      <v-col no-gutters class="mr-1">
        <KDiagramLoadingContainer title="Loading table data..." />
      </v-col>
      <v-col no-gutters class="ml-1">
        <KDiagramLoadingContainer title="Loading Power diagram data..." />
      </v-col>
    </v-row>
    <v-row no-gutters style="height: 48%">
      <v-col no-gutters class="mr-1">
        <KDiagramLoadingContainer title="Loading table data charts..." />
      </v-col>

      <v-col no-gutters class="ml-1">
        <KDiagramLoadingContainer title="Loading Speed diagram data..." />
      </v-col>
    </v-row>
  </v-container>
</template>

  
  <script>
import KDiagramLoadingContainer from "./components/LoadingContainer.vue";
export default {
  name: "kDiagramLoadingView",
  components: {
    KDiagramLoadingContainer,
  },
  data() {
    return {};
  },
};
</script>
  
  
  <style>
.custom-select-height {
  height: 20px;
}
</style>
  